import type { IClient } from './client';
import type { IPayload } from './payload';

export enum EUserProfileIds {
	GUEST,
	CUSTOMER,
	CUSTOMER_ADMIN,
	APPLICATION_ADMIN,
	PORTAL_MANAGER,
	SELLER,
	INTEGRATOR,
}

export interface ITokens {
	token?: string | null;
	accessToken?: string | null;
	refreshToken?: string | null;
	refreshTokenExpiresAt?: Date | null;
}

interface IIntegrationTokens {
	userId: number;
	sellerId: number;
	clientId: number;
	tenantId: number;
	email: string;
	name: string;
	profileId: number;
	profile: string;
	profileImageUrl: string;
	token: string;
	refreshToken: string;
	refreshTokenExpiresAt?: Date | null;
}

export interface IUser extends ITokens {
	id: number;
	userId?: number;
	clientId?: number;
	email: string;
	password?: string;
	name: string;
	phone: string;
	document: string;
	profileImageUrl?: string;
	profileId: EUserProfileIds;
	userProfileId?: number;
	profilePermissions?: string[];
	profile?: string;
	client?: IClient;
	createdAt?: Date;
	updatedAt?: Date;
	inactivatedAt?: Date;
	tenantId: number;
	sellerId?: number;
	showSellerPortfolioOnly?: boolean;
	afvDiscountLimit?: number;
}

export interface IUsers extends IPayload<IUser> {}
